import { ChangeEvent, FC } from 'react';

import { addOrDelete } from 'utils/clickme';
import { CAMPAIGN_LANGUAGES, CampaignLanguage } from 'utils/constants/campaign';

import cpcFlexibleLanguageButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_language_button_click';
import { Cell, CellText, Checkbox, VSpacingContainer } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import useIsNewCampaign from 'utils/campaign/hooks/useIsNewCampaign';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

import { setCampaignLanguage } from 'store/models/createCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    legend: 'AdCreate.AdForm.AdLanguage.legend',
    language: {
        [CampaignLanguage.English]: 'AdCreate.AdForm.AdLanguage.ENGLISH',
        [CampaignLanguage.French]: 'AdCreate.AdForm.AdLanguage.FRENCH',
        [CampaignLanguage.German]: 'AdCreate.AdForm.AdLanguage.GERMAN',
    },
};

export const AdLanguages: FC = () => {
    const adLanguage = useSelector((state) => state.createCampaign.adLanguage);
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const isCampaignProcessCreate = useIsNewCampaign();
    const [isTouched, setIsTouchedOn] = useOnOffState(false);

    const dispatch = useDispatch();
    const trl = useTrls();

    const setLanguage = (event: ChangeEvent<HTMLInputElement>) => {
        if (!isTouched && isCampaignProcessCreate) {
            cpcFlexibleLanguageButtonClick({ vacancyId });
            setIsTouchedOn();
        }
        const result = addOrDelete(adLanguage, event.target.value, event.target.checked) as CampaignLanguage[];
        dispatch(setCampaignLanguage(result));
    };
    return (
        <MagritteFormField
            label={trl(TrlKeys.legend)}
            input={
                <VSpacingContainer default={12}>
                    {CAMPAIGN_LANGUAGES.map((language) => (
                        <Cell
                            key={language}
                            width="fit-content"
                            left={
                                <Checkbox
                                    onChange={setLanguage}
                                    value={language}
                                    checked={adLanguage.includes(language)}
                                    data-qa={`language-checkbox-${language}`}
                                />
                            }
                        >
                            <CellText>{trl(TrlKeys.language[language])}</CellText>
                        </Cell>
                    ))}
                </VSpacingContainer>
            }
        />
    );
};
